export enum CortanaComposeResultType {
    searching,
    loading,
    doradoResult,
    documentSuggestion,
    smartReplySuggestion,
    noResults,
}

export enum CortanaComposeResultSection {
    dorado = 'dorado',
    document = 'document',
    smartReply = 'smartReply',
}

export interface CortanaComposeResult {
    selectable: boolean;
    onSelected: (result: CortanaComposeResult) => void;
    type: CortanaComposeResultType;
    resultObject?: any;
}

export default CortanaComposeResult;
